import React, { useEffect, useState } from 'react'
import { useAxios } from '../../core/AxiosContext'
import { useGlobalDispatch } from '../../core/GlobalContext'
import { TOAST_DUCK, TOAST_STATE } from '../../core/actions'
import { fetchFinancierAction, updateUserDetailsAction } from '../../routes/financier/FinancierDuck'
import { EMAIL_FORMAT } from '../../utils/validations'
import Button from '../button'
import Input from '../input'
import Text from '../text'
import * as styles from './CardAttributes.css'

export const CardAttributes = ({ className, name, value, userId }) => {
  const { authAxios } = useAxios()
  const { financierDispatch, toastDispatch } = useGlobalDispatch()
  const [newAttributeValue, setNewAttributeValue] = useState({
    // For other attributes that needs to be updated, expand here
    email: '',
  })
  const [errorMessage, setErrorMessage] = useState({
    email: '',
  })
  const [editEmail, setEditEmail] = useState(false)

  const successToast = () => {
    fetchFinancierAction()(authAxios, financierDispatch)
    toastDispatch({
      type: TOAST_DUCK.SEND_TOAST,
      payload: { message: 'Email Id updated successfully!', type: TOAST_STATE.SUCCESS },
    })
  }

  const failureToast = error => {
    toastDispatch({
      type: TOAST_DUCK.SEND_TOAST,
      payload: { message: error || 'Email Id updation failed! Try again later', type: TOAST_STATE.ERROR },
    })
  }

  useEffect(() => {
    setErrorMessage(state => {
      return { ...state, email: EMAIL_FORMAT.test(newAttributeValue.email) ? '' : 'Invalid Email Id' }
    })
  }, [newAttributeValue])

  return (
    value && (
      <div className={`${styles.cardAttributes} ${className}`}>
        <Text size='0.82' color='#808B96' bold>
          {name.toUpperCase()}
        </Text>
        {name === 'Email Id' && editEmail ? (
          <div className={styles.attributeValueWithBtn}>
            <div className={styles.cardAttributes}>
              <Input
                placeholder={'Enter new email id'}
                value={newAttributeValue?.email}
                autoComplete='email'
                onChange={newVal =>
                  setNewAttributeValue(state => {
                    return { ...state, email: newVal }
                  })
                }
              />
              <Text size='0.8' color='var(--red-text-color)'>
                {errorMessage.email}
              </Text>
            </div>
            <div className={styles.editAction}>
              <Button
                label='Save changes'
                disabled={errorMessage.email}
                handleClick={() => {
                  console.log('Handle email', newAttributeValue.email)
                  updateUserDetailsAction(userId, { email: newAttributeValue.email })(authAxios)(
                    successToast,
                    failureToast
                  )
                  setEditEmail(false)
                }}
              />
              <Button label='Cancel' type='danger' handleClick={() => setEditEmail(false)} />
            </div>
          </div>
        ) : (
          <div className={styles.attributeValueWithBtn}>
            <Text size='0.95'>{value}</Text>
            {name === 'Email Id' && <Button type='text' label='Edit' handleClick={() => setEditEmail(true)} />}
          </div>
        )}
      </div>
    )
  )
}
